<template>
  <div class="buy">
    <Header :show="true" :isShadow="false" title="卡券购买" />
    <div class="pageFooterPage" style="margin-top: 20px">
      <div class="title">
        <h3 class="pageFlex">
          <span style="background-color: var(--depYelColor)"></span>
          购买项目
        </h3>
      </div>
      <van-cell-group class="product">
        <van-cell title="卡券名称" :value="infoData.productName" />
        <van-cell title="购买金额" :value="`${infoData.price} 元`" />
        <van-cell title="有效期" value="30 天" />
      </van-cell-group>
      <VTitle val="支付方式" :showLine="false" />
      <van-cell-group
        ><van-cell
          @click="showCoupons"
          class="balancePay"
          v-if="couponsList && couponsList.length > 0"
        >
          <template #title>
            <van-icon name="coupon-o" />
            <span>通用券</span>
            <span class="tag" v-if="count > 0">已选{{ count }}张</span>
          </template>
          <div class="balanceRight">
            <div class="right">
              <span class="labels" v-if="couponsDeduct > 0"
                >抵扣￥{{ $formatMoney(couponsDeduct, 1) }}</span
              >
              <van-icon name="arrow" />
            </div>
          </div> </van-cell
      ></van-cell-group>
      <van-button
        style="margin-top: 20px"
        type="danger"
        block
        :disabled="btnDisabeled()"
        @click="buyHandle"
        ><span>{{ btntext }}</span></van-button
      >
      <ValidCouponsPopup
        ref="validCouponsPopup"
        :couponsList="couponsList"
        @confirm="popupConfirm"
      ></ValidCouponsPopup>
    </div>
  </div>
</template>

<script>
import { getValidCoupons } from "api/onLine";
import { couponExchange } from "api/offLine";
import ValidCouponsPopup from "./components/ValidCouponsPopup";

export default {
  props: {},
  components: {
    ValidCouponsPopup,
  },
  data() {
    return {
      infoData: {
        productId: "",
        productName: "",
        price: 0,
        categoryId: "",
        upstreamId: "",
        buyerUserId: "",
        mouldId: "",
        shopId: "",
        cityCode: "",
        longitude: "",
        latitude: "",
      },
      couponsList: [],
      count: 0,
      couponsDeduct: 0,
      couponIds: [],
      btntext: "购买",
    };
  },
  created() {
    this.infoData = this.$route.query;
    if (this.infoData.price) {
      this.infoData.price = this.$formatMoney(Number(this.infoData.price), 1);
    } else {
      this.infoData.price = 0;
    }
    this.ident = this.$route.query.ident;
    this.getValidCoupons();
  },
  methods: {
    btnDisabeled() {
      let remain = this.couponsDeduct - this.infoData.price;
      if (this.infoData.price > 0 && this.count > 0) {
        if (remain >= 0) {
          this.btntext = "购买";
          return false;
        } else {
          this.btntext = "卡券余额不足";
          return true;
        }
      } else {
        this.btntext = "购买";
        return true;
      }
    },
    getValidCoupons() {
      getValidCoupons(
        this.infoData.categoryId,
        this.infoData.upstreamId,
        this.infoData.buyerUserId,
        this.infoData.mouldId
      ).then((res) => {
        if (res.status == 200) {
          this.couponsList = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
    showCoupons() {
      this.$refs.validCouponsPopup.open(this.infoData.price);
    },
    popupConfirm(data) {
      this.couponsDeduct = data.couponsDeduct;
      this.count = data.count;
      this.couponIds = data.couponIds;
    },
    buyHandle() {
      this.$confirm("您确定要支付吗？本券有效期为30天，请尽快使用！", "").then(
        () => {
          let params = {
            productId: this.infoData.productId,
            couponIds: this.couponIds,
            couponsCityCode: this.infoData.cityCode,
            couponsShopId: this.infoData.shopId,
            couponsLongitude: this.infoData.longitude,
            couponsLatitude: this.infoData.latitude,
            couponShopName: this.infoData.shopName,
          };
          this.$loading("支付中");
          couponExchange(params).then((res) => {
            if (res.status == 200) {
              this.$successSync("购买成功", () => {
                this.$push({
                  path: "coupons",
                });
              });
            } else {
              this.$error(res.message);
            }
          });
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.buy {
  .title {
    h3 {
      margin: 0 0 4px;
      font-weight: var(--defaultFontWeight);
      font-size: var(--middleFont);
      color: var(--titleColor);
      span {
        width: 5px;
        height: 16px;
        margin-right: 8px;
        border-radius: 20px;
      }
    }
  }
  .product {
    margin-top: 20px;
  }
  .van-cell-group {
    border-radius: 10px;
  }
  .balancePay {
    border-radius: 10px;
    .balanceRight {
      display: flex;
      align-items: center;
    }
    .tag {
      font-size: 12px;
      padding: 0px 5px;
      margin-left: 5px;
      color: #fff;
      background: #f90;
      height: 15px;
      display: flex;
      align-items: center;
      border-radius: 5px 0px 5px 0px;
    }
    .van-cell {
      justify-content: space-between;
      font-size: var(--middleFont);
    }
    .van-cell__title {
      display: flex;
    }
    .van-cell__value {
      flex: initial;
      justify-content: center;
      display: flex;
    }
  }
  .van-icon-coupon-o {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-right: 8px;
    color: var(--depYelColor);
  }
  .right {
    display: flex;
    float: right;
    align-items: center;
  }
  .labels {
    font-size: 16px;
    color: var(--redColor);
  }
  .labels:first-child {
    margin-right: 8px;
  }
}
</style>